"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  CALENDAR: 'CALENDAR',
  TOOLBAR_BUTTON_OK: 'TOOLBAR_BUTTON_OK',
  TOOLBAR_SHORTCUT: 'TOOLBAR_SHORTCUT'
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/lib/DateRangePicker/Type.js
// module id = 613
// module chunks = 0